module.exports = __webpack_public_path__ + "GW.png?c92da4ec363182f73faff81b5c5f7a38";